import React, { useState } from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { PollOptionProps, PollProps, PollResponseProps } from "../../types"
import { useColors } from '../../constants/useColors';
import { Icons } from '../../Components';
import { FlatList } from 'react-native';

type FlashRowProps = {
    market_type:'FOR_MONEY'|'FREE',
    poll:PollProps,
    poll_responses:PollResponseProps[],
    poll_options:PollOptionProps[],
    width:number
}

const FlashRow = ({ market_type, poll, poll_options, poll_responses, width }:FlashRowProps) => {
    const Colors = useColors();
    const [ expanded, setExpanded ] = useState(false);

    const cl = market_type == 'FOR_MONEY' ? '$' : 'E'
    const risk = poll_responses.reduce((a,b) => a + parseFloat(b.stake as string), 0);
    const settled = poll.status == 'closed' ? true : false
    const winnings = poll_responses.reduce((a,b) => a + b.winnings, 0);

    const renderResponses = (data:{ item:PollResponseProps, index:number }) => {
        const option = poll_options.find(o => o.poll_option_id == data.item.poll_option_id);
        if(!option){ return <></> }
        return (
            <View type='row' style={{ borderBottomWidth:1, borderColor:Colors.borders.light }}>
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1' size={12}>{option.option_name}</Text>
                </View>
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1' size={12}>{cl}{parseFloat(data.item.stake as string).toFixed(2)}</Text>
                    <Text theme='light' size={12}>Risk</Text>
                </View>
            </View>
        )
    }

    return (
        <View>
            <View type='row' style={{ padding:10, borderBottomWidth:1, borderColor:Colors.borders.light, flexWrap:'wrap' }}>
                <Icons.FlameIcon size={25} color={Colors.text.h1} />
                <Button transparent style={{ borderRadius:0, padding:0, borderLeftWidth:1, borderColor:Colors.borders.light, flexGrow:1, marginLeft:6, paddingLeft:6, minWidth:75 }} onPress={() => setExpanded(!expanded)}>
                    <Text theme='h1' style={{ maxWidth:width * 0.55 }}>{poll.poll_question}</Text>
                    <Text theme='light' style={{ marginTop:3 }} color={Colors.text.action}>See {poll_responses.length} Responses</Text>
                </Button>
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1'>{cl}{risk.toFixed(2)}</Text>
                    <Text theme='light'>Risk</Text>
                </View>
                {settled ?
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1'>{cl}{winnings.toFixed(2)}</Text>
                    <Text theme='light'>Winnings</Text>
                </View>
                :<></>}
            </View>
            {expanded ?
            <View transparent style={{ padding:10 }}>
                <FlatList
                    data={poll_responses}
                    keyExtractor={item => item.poll_response_id.toString()}
                    renderItem={renderResponses}
                    key={`flash_${poll.poll_id}_responses`}
                    />
            </View>
            :<></>}
        </View>
    )
}

export default FlashRow